export const calculateYearPeriod = (date: Date): [Date, Date] => {
	const fromDate = new Date(date);
	fromDate.setDate(1);
	fromDate.setFullYear(fromDate.getFullYear() - 1);

	const toDate = new Date(date);
	toDate.setDate(1);
	toDate.setMonth(toDate.getMonth() - 1);

	return [fromDate, toDate];
};
